import React from "react";
import { Layout } from "antd";
import Navbar from "./Navbar";

const BasicLayout = (props) => {
  return (
    <Layout>
      <Navbar />
      <div style={{ marginTop: "2rem" }}>{props.children}</div>
    </Layout>
  );
};

export default BasicLayout;
